/* eslint-disable no-prototype-builtins */
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import MailContainer from "./MailContainer";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import React from "react";
import Spinner from "./Spinner";
import classNames from "classnames";
import styles from "../styles/Mail.module.scss";
import useDarkMode from "use-dark-mode";

const Mail = ({
  desc,
  description,
  destination,
  email,
  errors,
  fileInput,
  isPosting,
  onCaptcha,
  onChangeDesc,
  onChangeEmail,
  onFileChosen,
  onSubmit,
  success,
}) => {
  const darkMode = useDarkMode(false);
  return (
    <div className={classNames(styles.container, { [styles.dark]: darkMode.value })}>
      <div className={styles.containerInner}>
        {description}
        <form
          onSubmit={e => {
            e.preventDefault();
            onSubmit(destination);
          }}
        >
          <FormGroup>
            <FormLabel>Email</FormLabel>
            <FormControl onChange={onChangeEmail} placeholder="Email" type="text" value={email} />
            {errors.hasOwnProperty("email") && <p className="help-block">{errors.email}</p>}
          </FormGroup>
          <FormGroup>
            <FormLabel>Message</FormLabel>
            <FormControl
              as="textarea"
              onChange={onChangeDesc}
              placeholder="Message"
              rows={5}
              value={desc}
            />
            {errors.hasOwnProperty("desc") && <p className="help-block">{errors.desc}</p>}
          </FormGroup>
          <FormGroup>
            <FormLabel>Attachment (optional)</FormLabel>
            <div className="form-group">
              <input onChange={onFileChosen} ref={fileInput} type="file" />
            </div>
            {errors.hasOwnProperty("file") && <p className="help-block">{errors.file}</p>}
          </FormGroup>
          <FormGroup>
            <FormLabel>Captcha</FormLabel>
            <ReCAPTCHA onChange={onCaptcha} sitekey="6Lce4KcUAAAAABGKupP_l1JmBkkDNj39TOOU3ulX" />
            {errors.hasOwnProperty("captcha") && <p className="help-block">{errors.captcha}</p>}
          </FormGroup>
          <FormGroup>
            <Button className="btn-block" disabled={isPosting || success.length > 0} type="submit">
              {isPosting ? <Spinner /> : success.length > 0 ? "Done" : "Submit"}
            </Button>
          </FormGroup>
          {errors.hasOwnProperty("submit") && (
            <div className={styles.padBottom}>
              <Alert variant="danger">{errors.submit}</Alert>
            </div>
          )}
          {success.length > 0 && (
            <div className={styles.padBottom}>
              <Alert variant="success">{success}</Alert>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

Mail.propTypes = {
  desc: PropTypes.string.isRequired,
  description: PropTypes.element,
  destination: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  fileInput: PropTypes.object.isRequired,
  isPosting: PropTypes.bool.isRequired,
  onCaptcha: PropTypes.func.isRequired,
  onChangeDesc: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onFileChosen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  success: PropTypes.string.isRequired,
};

export default MailContainer(Mail);
